import { useTranslation } from 'react-i18next';

import { type Column } from '@innovamat/glimmer-components';
import type { TestRow } from '../../../../../modules/test/test';

const useTestsAndResultsColumnsConfiguration = (): Column<TestRow>[] => {
  const { t } = useTranslation();

  return [
    {
      id: 'rowName',
      label: t('testsAndResultsView.testNameColumnLabel'),
      sortable: true,
      sortIgnoreCase: true,
      width: 300,
      minWidth: 300,
    },
    {
      id: 'password',
      label: t('common.password'),
      width: 100,
      minWidth: 100,
    },
    {
      id: 'separator-1',
      width: 1,
      separator: true,
    },
    {
      id: 'participation',
      label: t('testsAndResultsView.participationColumnLabel'),
      isLargeLabel: false,
      width: 120,
      minWidth: 120,
    },
    {
      id: 'report',
      label: t('testsAndResultsView.reportColumnLabel'),
      isLargeLabel: false,
      sortable: true,
      width: 150,
      minWidth: 150,
    },
    {
      id: 'separator-2',
      width: 1,
      separator: true,
    },
    {
      id: 'status',
      label: t('common.status'),
      width: 150,
      minWidth: 150,
    },
    {
      id: 'startDate',
      label: t('common.availableFrom'),
      isLargeLabel: false,
      sortable: true,
      width: 150,
      minWidth: 150,
    },
    {
      id: 'endDate',
      label: t('common.availableUntil'),
      isLargeLabel: false,
      sortable: true,
      width: 150,
      minWidth: 150,
    },
  ];
};

export { useTestsAndResultsColumnsConfiguration };
